// main Component
// use this for intigration

import React, { useState } from "react";
import MuiTab from "../../../CommonComponents/Tab/MuiTab";
import Investigationreports from "./Investigationreports";
import InvestigatorBlocks from "./InvestigatorBlocks";
import ApprovalInvoices from "../ApprovalInvoices";
import {
  ApprovalInvestigationMainTabs,
  // ApprovalInvestigationAssignedBlocks,
  ApprovalInvestigationListTabs,
  // InvestigatorDetailsArray,
  ApprovalInvestigationAssignedBlocksContents,
  InvestigationReportsData,
} from "../../../constants/approvalsData";
import { assignBlock } from "../../../constants/caseManagementData";
import { Box } from "@mui/material";
import {
  approvalFlagPutApi,
  approveInvoicesByCaseId,
  getIndividualBlockDetails,
  getInvestigationReport,
  getInvestigatorDetails,
  getInvoiceVendorBlock,
  getInvoicesByCaseId,
  getVendorBlock,
  putInvestigationReportsApproval,
  putInvestigationReportsReject,
  rejectInvoicesByCaseId,
} from "../../../Services/approval.service";
import { useEffect } from "react";
import useToaster from "../../../customHook/useToaster";
import style from "./Investigation.module.css";
import ApprovalActionPopper from "../ApprovalActionPopper";
import CommonButton from "../../../CommonComponents/CommonButton";
import { images } from "../../../Images/Svg";
import PdfOpener from "../../../CommonComponents/Modal/PdfOpener";
import { useDispatch, useSelector } from "react-redux";
import {
  blocksAssignedReducer,
  investigatorReducer,
} from "../../../Redux/Slice/ApprovalSlice/approvalVendorSlice";
import { isLoadingStateReducer } from "../../../Redux/Slice/loginSlice";
import InvestigationInvoice from "./InvestigationInvoice";
import InvestigationActionButtons from "./InvestigationActionButtons";
import {
  InvestigationButtonLabels,
  typeOfAudio,
  typeOfPlayer,
} from "../../../Utils/helper";
import VendorAssesment from "../../CaseManagement/Actions/AssesmentCalculator";
import CommonModal from "../../../CommonComponents/Modal/CommonModal";
import Approval from "../../CaseManagement/Actions/Approval";
import GradeCaseModal from "../../CaseManagement/Actions/GradeCase";
import ManuallyAssignCase from "../ManuallyAssignCase";
import DragDrop from "../../../CommonComponents/DragDrop/DragDrop";
import { options } from "../../../constants/utils";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../../../CommonComponents/Player/AudioPlayer";
import VideoPlayer from "../../../CommonComponents/Player/VideoPlayer";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import DocxOpener from "../../../CommonComponents/Modal/DocxOpener";

const { AodbeIcon } = images;
const Investigation = ({
  caseId,
  investigationsActiveTabValue,
  setInvestigationActiveTabValue,
  setVendorBlockIsClicked,
  vendorBlockisClicked,
  setIsVendorClicked,
  isVendorClicked,
  setRerenderApprovalCaseList,
  firstTabVal,
  tabStatus,
  isAssignedToCurrentUser,
}) => {
  const [activeInvestigationTab, setActiveInvestigationTab] = useState("");
  const [InvestigatorMainTabValue, setInvestigatorMainTabValue] = useState(0);
  const [vendorBlockActiveTabValue, setVendorBlockActiveTabValue] =
    useState(-1);
  // const [investigationThreeTabTabValue, setInvestigationThreeTabValue] =
  //   useState(0);
  const [openUploadDocuments, setOpenUploadDocuments] = useState(false);
  const [investigationStatusData, setInvestigationStatusData] = useState([]);
  const [investigationInvoiceData, setInvestigationInvoiceData] = useState({});
  const [investigatorIds, setInvestigatorsIds] = useState();
  const [
    indexOfInvestigatorsDeatilsArray,
    setIndexOfInvestigatorsDeatilsArray,
  ] = useState(0);
  const [
    InvestigationAssignedBlockValueArray,
    setInvestigationAssignedBlockValueArray,
  ] = useState({});
  const [investigators, setInvestigators] = useState([]);
  const [viewPDF, setViewPDF] = useState([]);
  const [isVendorAssementModalOpen, setIsVendorAssementModalOpen] =
    useState(false);
  const [isActionRejectOpen, setIsActionRejectOpen] = useState(false);
  const [isGradeCaseModalOpen, setIsGradeCaseModalOpen] = useState(false);
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [reassignType, setReassignType] = useState("");
  const [isManualAssignModelOpen, setIsManualAssignModelOpen] = useState(false);
  const [manualPopupData, setManualPopupData] = useState(null);
  const [
    investigationReportsDocumentDetails,
    setInvestigationReportsDocumentDetails,
  ] = useState([]);
  const [investigationStatus, setInvestigationStatus] = useState("");
  const [openReassignModal, setOpenReassignModal] = useState(false);
  const [investigatorDetails, setInvestigatorDetails] = useState([]);
  const [audioPlayerModalIsOpen, setAudioPlayerModalIsOpen] = useState(false);
  // const [rejectFlag, setRejectFlag] = useState();
  const { showToast } = useToaster();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const InvestigatorBlocksClickHandler = (event, value) => {
    setIndexOfInvestigatorsDeatilsArray(value);
    setInvestigationAssignedBlockValueArray([]);
  };
  const blocksAssigned = useSelector(
    (state) => state?.approvalVendorSlice?.blocksAssigned
  );

  const isAssigned =
    typeof isAssignedToCurrentUser === "undefined"
      ? true
      : isAssignedToCurrentUser;

  const InvestigationAssignedBlockClickHandler = (event) => {
    dispatch(isLoadingStateReducer(true));
    const checked = event?.target?.checked;
    let blockId = event?.target?.id;
    let data = {
      investigatorId: investigatorIds,
      blockIds: blocksAssigned.map((item) => {
        return Object.values(item)[0];
      }),
    };
    if (!checked) {
      let modifiedAssignedBlock = blocksAssigned.map((item) => {
        if (item?.id == blockId) {
          return {
            ...item,
            checked: false,
          };
        } else {
          return item;
        }
      });
      dispatch(blocksAssignedReducer(modifiedAssignedBlock));
    }
    if (checked) {
      let modifiedAssignedBlock = blocksAssigned.map((item) => {
        if (item?.id == blockId) {
          return {
            ...item,
            checked: true,
          };
        } else {
          return item;
        }
      });
      dispatch(blocksAssignedReducer(modifiedAssignedBlock));
      getIndividualBlockDetails(caseId, data)
        .then((response) => {
          const { message, data: responseData } = response;
          showToast(message, "success", true);
          dispatch(isLoadingStateReducer(false));
          let filteredData = responseData?.blockDetails[blockId];
          if (filteredData) {
            // Check if filteredData already exists in the array
            const isDataExists = Object.values(
              InvestigationAssignedBlockValueArray
            ).some((item) => item === blockId);
            if (!isDataExists) {
              setInvestigationAssignedBlockValueArray((prevArray) => ({
                ...prevArray,
                [blockId]: filteredData,
              }));
            }
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    } else {
      dispatch(isLoadingStateReducer(false));
      setInvestigationAssignedBlockValueArray((prevArray) => {
        const updatedArray = { ...prevArray };
        delete updatedArray[blockId];
        return updatedArray;
      });
    }
  };

  // getting investigatorID to pass in payload of investigation-details
  const getInvestigatorId = (
    status,
    assignedToInvestigatorsWithInvestigationStatus
  ) => {
    const investigator = assignedToInvestigatorsWithInvestigationStatus.find(
      (item) => item?.label === status
    );
    return investigator ? investigator?.investigatorId : null;
  };

  const ApprovalInvestigationMainTabsClickHandler = (event, value) => {
    let activeTab = event?.target?.innerText;
    dispatch(isLoadingStateReducer(true));
    let data = {
      caseId: caseId,
    };
    setVendorBlockActiveTabValue(-1);
    setIsVendorClicked(false);
    let updateStates = (message) => {
      dispatch(isLoadingStateReducer(false));
      setInvestigatorMainTabValue(activeTab);
      setVendorBlockIsClicked(true);
      setActiveInvestigationTab(activeTab);
      showToast(message, "success", true);
    };

    let setVendorDetails = (data, message) => {
      updateStates(message);
      setInvestigationStatus(data);
      const assignedToInvestigatorsWithInvestigationStatus = data;

      if (assignedToInvestigatorsWithInvestigationStatus?.length) {
        const vendorLabels = assignedToInvestigatorsWithInvestigationStatus.map(
          (item, index) => ({
            ...item,
            label: item?.investigatorDetails?.vendor_name,
            activeTab,
          })
        );
        setInvestigationStatusData(vendorLabels);
      } else {
        setInvestigationStatusData([]);
      }
    };

    if (activeTab === "Invoice") {
      return getInvoiceVendorBlock(data)
        .then((data) => {
          if (data?.success) {
            // let vendorsWithInvoices = data?.data?.invoiceDetails?.filter(
            //   (obj) =>
            //     obj?.freshInvoices?.length || obj?.previousInvoices?.length
            // );
            // setVendorDetails(vendorsWithInvoices);
            let vendorsWithInvoices =
              data?.data?.invoiceDetails?.filter((obj) => !obj?.message) || [];
            let message = data?.message;
            setVendorDetails(vendorsWithInvoices, message);
          }
          let isInvoice = data?.data?.invoiceDetails?.find(
            (obj) => !obj?.message
          );
          if (!isInvoice) {
            showToast("No Invoice Found", "error", true);
          } else {
            showToast(data?.message, "success", true);
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }
    getVendorBlock(data)
      .then((data) => {
        if (data?.success) {
          setVendorDetails(
            data?.data?.assignedToInvestigatorsWithInvestigationStatus,
            data?.message
          );
        }
        showToast(data?.message, "success", true);
      })
      .catch((error) => {
        dispatch(isLoadingStateReducer(false));
        showToast(error?.response?.data?.message, "error", true);
      });
  };
  const onUploadButtonClickHandler = () => {
    setOpenUploadDocuments(true);
  };

  const InvestigationVendorBlockClickHandler = (
    e,
    value,
    invoiceStatus,
    investigationStatus
  ) => {
    const details = investigationStatusData[value]?.investigatorDetails;
    const selectedStatus = investigationStatusData[value]?.label;
    const investigatorId = getInvestigatorId(
      selectedStatus,
      investigationStatusData
    );

    setInvestigatorsIds(investigatorId);
    const data = {
      caseId: caseId,
      investigatorId: investigatorId,
    };
    setInvestigatorDetails(details);
    dispatch(isLoadingStateReducer(true));
    const updateStates = () => {
      dispatch(isLoadingStateReducer(false));
      setIsVendorClicked(true);
      // showToast(data?.message, "success", true);
    };
    if (InvestigatorMainTabValue === ApprovalInvestigationMainTabs[0]?.label) {
      getInvestigatorDetails(data)
        .then((data) => {
          if (data?.success) {
            updateStates();
            const {
              vendor_name,
              mobile_number,
              city,
              email,
              case_grade,
              grade_status,
              grade_sub_status,
            } = data?.data?.investigatorDetails;
            dispatch(
              investigatorReducer({
                vendorName: vendor_name,
                mobileNumber: mobile_number,
                city: city,
                email: email,
                caseGrade: case_grade,
                gradeStatus: grade_status,
                gradeSubStatus: grade_sub_status,
              })
            );
            let modifiedAssignedBlock =
              data?.data?.investigatorDetails?.blocksAssigned.map((item) => {
                return {
                  id: item,
                  checked: false,
                };
              });
            dispatch(blocksAssignedReducer(modifiedAssignedBlock));
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
          setIsVendorClicked(false);
        });
    }
    if (InvestigatorMainTabValue === ApprovalInvestigationMainTabs[1]?.label) {
      dispatch(isLoadingStateReducer(true));
      getInvestigationReport(caseId, {
        vendor_employee_id: investigatorId,
      })
        ?.then((data) => {
          if (data?.success) {
            dispatch(isLoadingStateReducer(false));
            setInvestigationReportsDocumentDetails(data.data.reports);
            setViewPDF(Array(data.data.reports?.length)?.fill(false));
            if (!data.data.reports?.length) {
              setIsVendorClicked(false);
              return showToast(
                "No pending reports for approval",
                "error",
                true
              );
            }
            setIsVendorClicked(true);
            showToast("Reports fetched successfully", "success", true);
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }
    if (InvestigatorMainTabValue === ApprovalInvestigationMainTabs[2]?.label) {
      let freshInvoicesDetails =
        investigationStatusData?.[value]?.freshInvoices;
      let previousInvoicesDetails =
        investigationStatusData?.[value]?.previousInvoices;
      let invoiceInformation =
        investigationStatusData?.[value]?.invoiceInformation;
      let invoiceStatus = investigationStatusData?.[value]?.invoice_status;
      let hideActionButtoninvoiceStatus =
        investigationStatusData?.[value]?.invoiceStatus;
      let approvedInvoicesDetails =
        investigationStatusData?.[value]?.approvedInvoices;

      dispatch(isLoadingStateReducer(false));
      // if (invoiceStatus?.toLowerCase() === "approved") {
      //   setIsVendorClicked(false);
      //   return showToast(
      //     "Invoice already approved for this vendor",
      //     "info",
      //     true
      //   );
      // }
      if (
        !freshInvoicesDetails?.length &&
        !previousInvoicesDetails?.length &&
        !approvedInvoicesDetails?.length
      ) {
        setIsVendorClicked(false);
        return showToast("No invoice found for this vendor", "error", true);
      }
      setInvestigationInvoiceData(
        {
          freshInvoicesDetails,
          previousInvoicesDetails,
          invoiceInformation,
          hideActionButtoninvoiceStatus,
          approvedInvoicesDetails,
          invoiceStatus,
        } || {}
      );
      setIsVendorClicked(true);
      // getInvoicesByCaseId(caseId, { vendor_employee_id: investigatorId })
      //   ?.then((response) => {
      //     if (response?.success) {
      //       dispatch(isLoadingStateReducer(false));
      //       if (
      //         !response?.data?.invoices?.freshInvoicesDetails?.length &&
      //         !response?.data?.invoices?.previousInvoicesDetails?.length
      //       ) {
      //         setIsVendorClicked(false);
      //         return showToast(
      //           "No pending invoice for approval",
      //           "error",
      //           true
      //         );
      //       }
      //       setInvestigationInvoiceData(response?.data?.invoices || {});
      //       setIsVendorClicked(true);
      //       showToast(response?.message, "success", true);
      //     }
      //   })
      //   ?.catch((error) => {
      //     dispatch(isLoadingStateReducer(false));
      //     setInvestigationInvoiceData({});
      //     showToast(error?.response?.data?.message, "error", true);
      //   });
    }
  };
  const refreshInvoiceList = (type) => {
    const updateStates = () => {
      dispatch(isLoadingStateReducer(false));
      if (type === "invoice") {
        setIsVendorClicked(false);
        setVendorBlockActiveTabValue(-1);
      }
      // setTimeout(() => {
      //   setIsVendorClicked(true);
      // }, 50);
    };

    const getInvoices = (data) => {
      let activeInvoiceData = data?.find(
        (obj) => obj?.investigatorId == investigatorIds
      );
      let freshInvoicesDetails = activeInvoiceData?.freshInvoices;
      let previousInvoicesDetails = activeInvoiceData?.previousInvoices;
      let invoiceInformation = activeInvoiceData?.invoiceInformation;
      let approvedInvoicesDetails = activeInvoiceData?.approvedInvoices;
      let invoiceStatus = activeInvoiceData?.invoiceStatus;
      updateStates();
      setInvestigationInvoiceData(
        {
          freshInvoicesDetails,
          previousInvoicesDetails,
          invoiceInformation,
          approvedInvoicesDetails,
          invoiceStatus,
        } || {}
      );
      // getInvoicesByCaseId(caseId, { vendor_employee_id: investigatorIds })
      //   ?.then((response) => {
      //     if (response?.success) {
      //       updateStates();
      //       setInvestigationInvoiceData(response?.data?.invoices || {});
      //       // if (!response?.data?.invoices?.length) {
      //       //   showToast("No pending invoice for approval", "error", true);
      //       // }
      //     }
      //   })
      //   ?.catch((error) => {
      //     dispatch(isLoadingStateReducer(false));
      //     showToast(error?.response?.data?.message, "error", true);
      //   });
    };

    const getReports = () => {
      getInvestigationReport(caseId, { vendor_employee_id: investigatorIds })
        ?.then((data) => {
          if (data?.success) {
            updateStates();
            setInvestigationReportsDocumentDetails(data.data.reports);
            setViewPDF(Array(data.data.reports?.length)?.fill(false));
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    };

    let setVendorDetails = (data) => {
      setInvestigationStatus(data);
      const assignedToInvestigatorsWithInvestigationStatus = data;

      if (assignedToInvestigatorsWithInvestigationStatus?.length) {
        const vendorLabels = assignedToInvestigatorsWithInvestigationStatus.map(
          (item, index) => ({
            ...item,
            label: item?.investigatorDetails?.vendor_name,
            activeTab: InvestigatorMainTabValue,
          })
        );

        setInvestigationStatusData(vendorLabels);
      } else {
        setInvestigationStatusData([]);
      }
    };

    if (type === "invoice") {
      return getInvoiceVendorBlock({ caseId })
        .then((data) => {
          if (data?.success) {
            // let vendorsWithInvoices = data?.data?.invoiceDetails?.filter(
            //   (obj) =>
            //     obj?.freshInvoices?.length || obj?.previousInvoices?.length
            // );
            let vendorsWithInvoices =
              data?.data?.invoiceDetails?.filter((obj) => !obj?.message) || [];
            getInvoices(vendorsWithInvoices);
            setVendorDetails(vendorsWithInvoices);
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }

    getVendorBlock({ caseId })
      .then((data) => {
        if (data?.success) {
          // if (type === "invoice") getInvoices();
          if (type === "reports") getReports();
          setVendorDetails(
            data?.data?.assignedToInvestigatorsWithInvestigationStatus
          );
        }
      })
      .catch((error) => {
        dispatch(isLoadingStateReducer(false));
        showToast(error?.response?.data?.message, "error", true);
      });
  };

  const onActionSubmit = (data) => {
    dispatch(isLoadingStateReducer(true));
    let selectedVendorDetails = investigationStatusData?.find(
      (obj) => obj?.investigatorId == investigatorIds
    );
    const payload = {
      vendor_employee_id: investigatorIds,
      invoice_remark: data?.remark,
      invoice_ids:
        selectedVendorDetails?.freshInvoices
          ?.map(
            (obj) =>
              obj?.invoice_documents?.map(
                (item) => item?.invoice_documents_id
              ) || []
          )
          ?.flat(1) || [],
    };
    if (data?.type === InvestigationButtonLabels[1]) {
      approveInvoicesByCaseId(caseId, payload)
        ?.then((response) => {
          if (response?.success) {
            dispatch(isLoadingStateReducer(false));
            data?.setOpenActionModal(false);
            setIsVendorClicked(false);
            showToast(response?.message, "success", true);
            refreshInvoiceList("invoice");
          }
        })
        ?.catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    } else if (data?.type === InvestigationButtonLabels[2]) {
      rejectInvoicesByCaseId(caseId, payload)
        ?.then((response) => {
          if (response?.success) {
            dispatch(isLoadingStateReducer(false));
            data?.setOpenActionModal(false);
            setIsVendorClicked(false);
            showToast(response?.message, "success", true);
            refreshInvoiceList("invoice");
          }
        })
        ?.catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    } else {
      approvalFlagPutApi(caseId, { star: true })
        ?.then((response) => {
          if (response?.success) {
            dispatch(isLoadingStateReducer(false));
            setRerenderApprovalCaseList();
            showToast(response?.message, "success", true);
          }
        })
        ?.catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }
  };
  const investigationReportsActionModalHandler = (e, label) => {
    if (label === InvestigationButtonLabels[0]) {
      approvalFlagPutApi(caseId, { star: true })
        .then((data) => {
          if (data?.success) {
            showToast(data?.message, "success", true);
            setRerenderApprovalCaseList();
          }
        })
        .catch((error) => {
          showToast(error?.response?.data?.message, "error", true);
        });
    }

    if (label === InvestigationButtonLabels[1]) {
      dispatch(isLoadingStateReducer(true));
      putInvestigationReportsApproval(caseId, {
        vendor_employee_id: investigatorIds,
      })
        .then((data) => {
          if (data?.success) {
            dispatch(isLoadingStateReducer(false));
            showToast(data?.message, "success", true);
            setIsVendorAssementModalOpen(true);
            refreshInvoiceList("reports");
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }

    if (label === InvestigationButtonLabels[2]) {
      setIsActionRejectOpen(true);
    }
  };

  const truncateMiddleText = (str, maxLength) => {
    if (str.length <= maxLength) {
      return str;
    }
    const firstPart = str.substr(0, maxLength / 2);
    const lastPart = str.substr(str.length - maxLength / 2);
    return `${firstPart}.....${lastPart}`;
  };
  // convert fileSize
  const formatFileSize = function (bytes) {
    const sufixes = ["B", "kB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sufixes[i]}`;
  };

  const pdfViewHandler = (index) => {
    setViewPDF((prev) => {
      let newViewPdf = prev.map((_, i) => i === index);
      return newViewPdf;
    });
  };
  const handleCloseModal = (index) => {
    setViewPDF((prev) => prev.map((_, i) => (i === index ? false : _)));
  };

  const getVendor = () => {
    return investigationStatusData?.indexOf(
      investigationStatusData?.find(
        (obj) => obj?.investigatorId == investigatorIds
      )
    );
  };

  const onAssignBlockHandler = (payload) => {
    setOpenReassignModal(false);
    setIsReassignModalOpen(false);
    if (reassignType === "manual") {
      setIsManualAssignModelOpen(true);
      setManualPopupData(payload);
      return;
    }
    dispatch(isLoadingStateReducer(true));
    refreshInvoiceList("reports");
  };

  const manualAssignHandler = () => {
    setManualPopupData(null);
    setIsManualAssignModelOpen(false);
    dispatch(isLoadingStateReducer(true));
    refreshInvoiceList("reports");
  };

  useEffect(() => {
    if (investigationsActiveTabValue === -1) {
      setVendorBlockIsClicked(false);
    }
    return () => {
      if (vendorBlockActiveTabValue === -1) {
        setInvestigationAssignedBlockValueArray([]);
        setViewPDF([]);
      }
    };
  }, [investigationsActiveTabValue]);

  useEffect(() => {
    setInvestigationAssignedBlockValueArray({});
  }, [vendorBlockActiveTabValue]);
  return (
    <Box
      sx={{
        background: "#FFFFFF",
        boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
        padding: "3.3rem",
      }}
    >
      <MuiTab
        tabs={ApprovalInvestigationMainTabs}
        variant="gray"
        onClick={ApprovalInvestigationMainTabsClickHandler}
        fontSize="1.1rem"
        padding="9px"
        activeTab={investigationsActiveTabValue}
        setActiveTab={setInvestigationActiveTabValue}
      />
      <div
        className={
          vendorBlockisClicked && investigationsActiveTabValue !== -1
            ? style["investigation-reports-main"]
            : null
        }
      >
        {vendorBlockisClicked &&
          (investigationStatusData?.length ? (
            <>
              <h2 className={style["investigation-reports-header"]}>
                Select Investigator to view details
              </h2>
              <MuiTab
                tabs={investigationStatusData}
                variant="gray"
                fontSize="1.1rem"
                onClick={InvestigationVendorBlockClickHandler}
                activeTab={vendorBlockActiveTabValue}
                setActiveTab={setVendorBlockActiveTabValue}
              />
            </>
          ) : (
            <h2 className={style["investigation-no-data"]}>No Data</h2>
          ))}
        {isVendorClicked && (
          <>
            {InvestigatorMainTabValue ===
            ApprovalInvestigationMainTabs[0]?.label ? (
              <InvestigatorBlocks
                caseId={caseId}
                investigators={investigators}
                setInvestigators={setInvestigators}
                indexOfInvestigatorsDeatilsArray={
                  indexOfInvestigatorsDeatilsArray
                }
                InvestigatorBlocksClickHandler={InvestigatorBlocksClickHandler}
                InvestigationAssignedBlockClickHandler={
                  InvestigationAssignedBlockClickHandler
                }
                InvestigationAssignedBlockValueArray={
                  InvestigationAssignedBlockValueArray
                }
                onUploadButtonClickHandler={onUploadButtonClickHandler}
                openUploadDocuments={openUploadDocuments}
                setOpenUploadDocuments={setOpenUploadDocuments}
                ApprovalInvestigationAssignedBlocks={assignBlock}
                ApprovalInvestigationListTabs={ApprovalInvestigationListTabs}
                InvestigatorTabDetails={blocksAssigned}
                ApprovalInvestigationAssignedBlocksContents={assignBlock}
              />
            ) : InvestigatorMainTabValue ===
              ApprovalInvestigationMainTabs[1]?.label ? (
              <>
                <div className={style["uploadReports-div"]}>
                  <h3>Uploaded Reports</h3>
                  <div>
                    {investigationStatus[vendorBlockActiveTabValue]
                      ?.investigationStatus === "review" && (
                      <>
                        <div className={style["btn-div"]}>
                          {!["Invoice", "Garage", "Hospital"].includes(
                            firstTabVal
                          ) ? (
                            <InvestigationActionButtons
                              onClick={investigationReportsActionModalHandler} //hide action button if isActive is false
                              hideButton={
                                investigationStatusData?.some(
                                  (item) =>
                                    item?.investigatorId === investigatorIds &&
                                    !item?.isActive
                                ) ||
                                firstTabVal === "Submitted" ||
                                tabStatus === "closed" ||
                                !isAssigned
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <p
                          style={{
                            marginTop: "1rem",
                            color: "#737D8C",
                            fontWeight: 700,
                            fontSize: "1.2rem",
                          }}
                        >
                          Case Reassigned to :{" "}
                          {investigatorDetails?.reassigned_to
                            ? investigatorDetails?.reassigned_to
                            : "-"}
                        </p>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {investigationReportsDocumentDetails?.map((item, index) => (
                    <>
                      <div
                        className={style["file-conatiner"]}
                        style={
                          viewPDF[index]
                            ? {
                                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                              }
                            : {}
                        }
                        onClick={() => pdfViewHandler(index)}
                      >
                        <div className={style["Uploadimage-div"]} key={index}>
                          <img src={AodbeIcon} alt="AodbeIcon" />
                          <div>
                            <p className={style["fileName"]}>
                              {truncateMiddleText(item?.document_name, 10)}
                            </p>
                            <p className={style["fileSize"]}>
                              {item?.document_size}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        {viewPDF[index] &&
                          (item?.document_name?.split(".")?.pop() === "pdf" ||
                          item?.document_name?.split(".")?.pop() === "PDF" ? (
                            <CommonModal
                              width="45%"
                              height="90%"
                              open={viewPDF[index]}
                              onClose={() => handleCloseModal(index)}
                              showDownloadIcon={true}
                              downloadFilePath={item?.document_path}
                              downloadFileName={item?.document_name}
                              fullsize
                            >
                              <PdfOpener pdfFileLink={item?.document_path} />
                            </CommonModal>
                          ) : item?.document_name?.split(".")?.pop() ===
                            "docx" ? (
                            <CommonModal
                              open={viewPDF[index]}
                              onClose={() => handleCloseModal(index)}
                              showDownloadIcon={true}
                              downloadFilePath={item?.document_path}
                              downloadFileName={item?.document_name}
                              fullsize
                            >
                              <DocxOpener
                                fileName={item?.document_path}
                                fileType={item?.document_name
                                  ?.split(".")
                                  ?.pop()}
                              />
                            </CommonModal>
                          ) : typeOfAudio?.includes(
                              item?.document_name?.split(".")?.pop()
                            ) ? (
                            <CommonModal
                              open={viewPDF[index]}
                              onClose={() => handleCloseModal(index)}
                            >
                              <AudioPlayer
                                src={item?.document_path}
                                type={item?.document_name?.split(".")?.pop()}
                              />
                            </CommonModal>
                          ) : typeOfPlayer?.includes(
                              item?.document_name?.split(".")?.pop()
                            ) ? (
                            <CommonModal
                              width="50%"
                              height="60%"
                              open={viewPDF[index]}
                              onClose={() => handleCloseModal(index)}
                              fullsize
                            >
                              <VideoPlayer
                                width="100%"
                                height="90%"
                                src={item?.document_path}
                                type={item?.document_name?.split(".")?.pop()}
                              />
                            </CommonModal>
                          ) : (
                            <CommonModal
                              width="50%"
                              open={viewPDF[index]}
                              onClose={() => handleCloseModal(index)}
                              showDownloadIcon={true}
                              downloadFilePath={item?.document_path}
                              downloadFileName={item?.document_name}
                              isImage
                              fullsize
                            >
                              <div
                                style={{
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                              >
                                <ReactPanZoom
                                  alt={item?.document_path}
                                  image={item?.document_path}
                                />
                              </div>
                            </CommonModal>
                          ))}
                      </div>
                    </>
                  ))}
                </div>

                <CommonModal
                  open={isVendorAssementModalOpen}
                  onClose={() => setIsVendorAssementModalOpen(false)}
                >
                  <VendorAssesment
                    caseId={caseId}
                    setOpenActionModal={setIsVendorAssementModalOpen}
                    vendorId={investigatorIds}
                    vendorIdToDisplay={vendorBlockActiveTabValue + 1}
                    vendorBlockActiveTabValue={vendorBlockActiveTabValue}
                  />
                </CommonModal>
                <CommonModal
                  open={isActionRejectOpen}
                  onClose={() => setIsActionRejectOpen(false)}
                >
                  <Approval
                    // message="Are you rejecting because of Vendor Quality"
                    message="Do you want to re-assign the case?"
                    onClick={(flag) => {
                      // setRejectFlag(flag);
                      // if (flag) {
                      if (!flag) {
                        putInvestigationReportsReject(caseId, {
                          vendor_employee_id: investigatorIds,
                        })
                          .then((data) => {
                            if (data?.success) {
                              showToast(
                                "Please go to Action button and continue processing the case",
                                "success",
                                true
                              );
                              // showToast(data?.message, "success", true);
                              // setIsGradeCaseModalOpen(true);
                              setIsActionRejectOpen(false);
                              refreshInvoiceList("reports");
                            }
                          })
                          .catch((error) => {
                            setIsActionRejectOpen(false);
                            showToast(
                              error?.response?.data?.message,
                              "error",
                              true
                            );
                          });
                      } else {
                        setIsActionRejectOpen(false);
                        // setIsVendorAssementModalOpen(true);
                        setIsReassignModalOpen(true);
                      }
                    }}
                    //
                  />
                </CommonModal>
                <CommonModal
                  open={isGradeCaseModalOpen}
                  onClose={() => {
                    setIsGradeCaseModalOpen(false);
                  }}
                >
                  <GradeCaseModal
                    setOpenActionModal={setIsGradeCaseModalOpen}
                  />
                </CommonModal>
                <CommonModal
                  label="Re-assign Case"
                  open={isReassignModalOpen}
                  onClose={() => {
                    setIsReassignModalOpen(false);
                  }}
                  width="42.1rem"
                  height="28rem"
                >
                  <Approval
                    message=""
                    isReassign={true}
                    onReassignClick={(type) => {
                      // setOpenReassignModal(true);
                      // setReassignType(type);
                      navigate(
                        `/re-assign/${vendorBlockActiveTabValue + 1}/${type}`
                      );
                    }}
                  />
                </CommonModal>
                <CommonModal
                  open={isManualAssignModelOpen}
                  onClose={() => {
                    setIsManualAssignModelOpen(false);
                  }}
                  width="44.3rem"
                >
                  <ManuallyAssignCase
                    caseId={caseId}
                    data={manualPopupData}
                    onSubmit={manualAssignHandler}
                  />
                </CommonModal>
                <CommonModal
                  label={"Assign Block"}
                  width="60%"
                  height="75%"
                  open={openReassignModal}
                  showCrossIcon={true}
                  onClose={() => setOpenReassignModal(false)}
                >
                  <DragDrop
                    label={"Assign Block"}
                    options={options}
                    isReassign={true}
                    reassignType={reassignType}
                    investigatorDetails={investigatorDetails}
                    onAssign={onAssignBlockHandler}
                  />
                </CommonModal>
              </>
            ) : InvestigatorMainTabValue ===
              ApprovalInvestigationMainTabs[2]?.label ? (
              <InvestigationInvoice
                invoiceData={investigationInvoiceData}
                onActionSubmit={onActionSubmit}
                firstTabVal={firstTabVal}
                tabStatus={tabStatus}
                isAssignedToCurrentUser={isAssignedToCurrentUser}
              />
            ) : null}
          </>
        )}
      </div>
    </Box>
  );
};

export default Investigation;
